// Barrel re-export — all bulk-filter functionality split into domain modules
export type { ContactFilterCriteria } from "./contacts-types";
export type {
  BulkActionProgressItem,
  BulkActionProgress,
  FilterBasedBulkActionParams,
} from "@/lib/hooks/api/shared/bulk-filter-types";

export { RateLimitedBulkActionExecutor, buildContactFilterQuery, getFilteredContactIds } from "./contacts-bulk-filter-utils";

export {
  useBulkUpdateContactStatusByFilter,
  useBulkDeleteContactsByFilter,
  useBulkArchiveContactsByFilter,
} from "./contacts-bulk-filter-actions";

export {
  useBulkExportContactsByFilter,
  useBulkEmailContactsByFilter,
  useBulkExportContactsEmailsByFilter,
} from "./contacts-bulk-filter-export";

// Converts a generic filter state object into ContactFilterCriteria
export function useContactFilterCriteria(
  filters: Record<string, unknown>,
  companyFilter?: string
): import("./contacts-types").ContactFilterCriteria {
  return {
    nameSearch: (filters.nameSearch as string) || undefined,
    companySearch: (filters.companySearch as string) || undefined,
    emailSearch: (filters.emailSearch as string) || undefined,
    status: filters.contractType !== "all" ? (filters.contractType as string) : undefined,
    isActive:
      filters.isActive !== "all"
        ? (filters.isActive as string) === "true"
        : undefined,
    company_name: companyFilter || undefined,
  };
}
